import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { User as AuthUser } from '@appstrax/services/auth';
import { User } from '@models';

import { UserActions } from './user.actions';
import { userFeature } from './user.reducer';

@Injectable({ providedIn: 'root' })
export class UserFacade {
  private store = inject(Store);

  readonly current = toSignal(this.store.select(userFeature.selectCurrent), { initialValue: null });
  readonly loading = toSignal(this.store.select(userFeature.selectLoading), { initialValue: false });
  readonly error = toSignal(this.store.select(userFeature.selectError), { initialValue: null });

  loadCurrent(): void {
    this.store.dispatch(UserActions.loadCurrent());
  }

  setCurrentFromAuthUser(authUser: AuthUser): void {
    const user = new User();
    user.id = authUser.id;
    user.email = authUser.email;
    this.store.dispatch(UserActions.setCurrent({ user }));
  }

  setCurrent(user: User | null): void {
    this.store.dispatch(UserActions.setCurrent({ user }));
  }

  clear(): void {
    this.store.dispatch(UserActions.cleared());
  }
}
